FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    //  Constants
    var ELEM = '[data-fd="table-resize"]',
        NORESIZE_ELEM = '[data-fd="noresize"]';

    $.widget("custom.tableResize", {
        _sortCtrl: {
            none: "<span class='sort-ctrl color-white pr-2'><i class='fa fa-sort'></i></span>",
            asc: "<span class='sort-ctrl color-white pr-2'><i class='fa fa-caret-up' ></i></span>",
            desc: "<span class='sort-ctrl color-white pr-2'><i class='fa fa-caret-down'></i></span>",
        },
        _scrollDelay: null,
        _sortTHList: null,
        _currentSortID: null,
        _tableWidth: 0,
        _highlightClass: null,
        _highlightChild: null,
        options: {
            element: '',
            child: null,
            childid: '',
            resize: true,
            collapserow: false,
            isrowcollapsed: false,
            ishighlight: true,
            ishighlightFirstRecord: true,
            ishighlightborder: true,
            sortable: false,
            sortabletag: 901,
            headersort: false,
            sorttag: 82,
            useheaderrow: null,
            handle: '.handle',
            callback: 'PAGE.getAfterControlEvent',
            callbackprefix: 1
        },
        _create: function () {
            $.extend(this.options, this.element.data());

            this.element.addClass("table-resize");
            // If use header row isn't defined, assume the last header row is the master one
            if (this.options.useheaderrow === null) {
                this.options.useheaderrow = this.element.find('thead tr').length - 1;
            }

            if (this.options.child !== null) {
                var child = $(this.options.child);
                if (child.length > 0) {
                    this.options.child = child;
                    this.options.childlength = child.length;
                    this.options.childid = '#' + child[0].id;
                } else {
                    this.options.child = null;
                    this.options.childlength = 0;
                    this.options.childwrapper = null;
                }
            } else {
                this.options.child = this.element;
            }

            this.element.data(this.options); // NOTE: This should eventualy be removed.

            if (this.options.collapserow) {
                this._setCollapseRow();
            }

            if (this.options.headersort) {
                this._setHeaderSort();
            }
            this._initChildTable();

            if (this.options.resize) {
                this._setTableResize();
            }

            if (this.options.sortable) {
                this._setSortable();
            }

            if (this.options.ishighlight) {
                this._setHighlightRow();
            }
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.refresh();
        },
        refresh: function () {
        },
        _destroy: function () {
            var NAMESPACE = me.getUID('CTRL_');

            this.element.removeClass("table-resize");
            this.element
                .off('click.sort', '.sort-control', this._clickColumnSort)
                .off('click.' + NAMESPACE, '#COLLAPSETABLE', this._clickCollapseTable)
                .removeAttr("style");
            $(this.options.child)
                .off('click.highlighttablerow', '', this._highLightByTarget)
                .off('keyup.highlighttablerow', '', this._highLightByTarget)
                .removeAttr("style");

            var thMainList = this.element.find("tr:eq(" + this.options.useheaderrow + ") th");
            thMainList.each(function () {
                $(this).addClass($(this).data("widthClass"));
            });

            $('colgroup', this.element).remove();
            $('colgroup', this.options.child).remove();
        },

        /* ========================================================================
         * header sort
         * ========================================================================*/

        _setHeaderSort: function () {
            var self = this;
            var options = {
                tag: this.options.sorttag,
                callback: me.setCallBackPrefix(this.options.callbackprefix),
                sortid: 0
            };

            this._sortTHList = this.element.find("th[data-fd='thsort']");
            if (this._sortTHList.length) {
                this._sortTHList.each(function (i) {
                    var th = $(this);
                    if (th.data('direction') != undefined) {
                        options.direction = th.data('direction').toString();
                        options.initialdir = options.direction;
                    } else {
                        options.direction = 'none';
                        options.initialdir = th.data('initialdir');
                    }

                    options.sortfield = th.data('sortfield') || 'noFldName';

                    th.data(options);
                    th.attr('id', me.getUID('SRT_'));

                    self._setSortColumnIcon(th, options.direction);
                });

                $(this.element).on('click.sort', '.sort-control', this, this._clickColumnSort);
            }
        },
        _setSortColumnIcon: function (th, direction) {
            direction = direction.toLowerCase();

            th.removeClass('sort-control');
            th.find('.sort-ctrl').remove();

            switch (direction) {
                case '0':
                case 'asc':
                case 'ascending':
                    th.prepend(this._sortCtrl.asc).addClass('sort-control').addClass('in');
                    th.data('sortid', 0);
                    break;
                case '1':
                case 'desc':
                case 'descending':
                    th.prepend(this._sortCtrl.desc).addClass('sort-control').addClass('in');
                    th.data('sortid', 1);
                    break;
                default:
                    th.prepend(this._sortCtrl.none).addClass('sort-control').removeClass('in');
                    th.data('sortid', -1);
                    break;
            }
        },
        _clickColumnSort: function (event) {
            event.preventDefault();
            var self = event.data;
            var th = $(this);
            var data = th.data();
            var sortid = data.sortid;
            var id = th.attr('id');

            if (self._currentSortID !== null || self._currentSortID !== id) {
                self._sortTHList.not(this).each(function (i) {
                    self._setSortColumnIcon(th, 'none');
                });
            }

            if (self._scrollDelay) {
                clearTimeout(self._scrollDelay);
            }
            self._scrollDelay = setTimeout(function () {
                th.find('.sort-ctrl').remove();
                switch (sortid) {
                    case 0:
                        th.prepend(self._sortCtrl.desc).addClass('in');
                        th.data('sortid', 1);
                        break;
                    case 1:
                        th.prepend(self._sortCtrl.asc).addClass('in');
                        th.data('sortid', 0)
                        break;
                    case -1:
                        if (data.initialdir == 0 || (typeof data.initialdir === 'string' && data.initialdir.toLowerCase().startsWith('asc'))) {
                            th.prepend(self._sortCtrl.asc).addClass('in');
                            th.data('sortid', 0);
                        } else {
                            th.prepend(self._sortCtrl.desc).addClass('in');
                            th.data('sortid', 1);
                        }
                        break;
                }

                data = th.data();
                me.setCallBackFromData(th, { e: th, value: data.sortid, tag: data.tag, sortfield: data.sortfield, parentid: null });
            }, 300);
        },

        /* ========================================================================
         * resize
         * ========================================================================*/

        _setTableResize: function () {
            var options = {
                handles: 'e',
                stop: this._stopResize,
                resize: this._resizeColGroup,
                helper: "ui-resizable-handle"
            };
            this.element.find("tr:eq(" + this.options.useheaderrow + ") th:not(" + NORESIZE_ELEM + ")").resizable(options);
        },
        _stopResize: function (event, ui) {
            var self = $(this).closest("table").data("custom-tableResize");
            var elem = $(this);
            var props = {
                col: elem,
                parent: elem.parents('table'),
                index: elem.index() + 1,
                width: ui.originalSize.width,
                newwidth: ui.size.width,
                diff: (ui.size.width - ui.originalSize.width)
            };
            $('colgroup', self.element).find('col:eq(' + elem[0].cellIndex + ')').attr('width', props.newwidth);
            self._tableWidth = self._tableWidth + (props.diff);

            self.element.css('width', self._tableWidth);
            self.options.child.css('width', self._tableWidth);

            me.setPageDimension();
        },
        _resizeColGroup: function (event, ui) {
            var self = $(this).closest("table").data("custom-tableResize");
            $('colgroup', self.options.child).find('col:eq(' + ui.element[0].cellIndex + ')').attr('width', ui.size.width);
            if (self.options.child != self.element) {
                $('colgroup', self.element).find('col:eq(' + ui.element[0].cellIndex + ')').attr('width', ui.size.width);
            }
        },

        /* ========================================================================
         * highlight
         * ========================================================================*/

        _setHighlightRow: function () {
            this._highlightClass = this.options.ishighlightborder ? "highlight-child-withborder" : "highlight-child";
            this._highlightChild = this.options.child ? $("tbody", this.options.child) : $("tbody", this.element);
            //  add highlight to 1st row
            if (this.options.ishighlightFirstRecord) {
                this._highlightChild.find('tr:eq(0)').addClass(this._highlightClass);
            }

            $(this.options.child)
                .on('click.highlighttablerow', '', this, this._highLightByTarget)
                .on('keyup.highlighttablerow', '', this, this._highLightByTarget);
        },
        _highLightByTarget: function (event) {
            if ($(event.target).is("table")) {
                return;
            }
            var self = event.data;
            if (self._highlightChild.find(event.target).length) {
                var tr = $(event.target).parents('tr');
                self._highlightChild.find('tr').removeClass(self._highlightClass);
                if (tr.data('nohighlight') === true) {
                    return;
                }

                tr.addClass(self._highlightClass);
            } else {
                self._highlightChild.find('tr').not('.static').removeClass(self._highlightClass);
            }
        },

        /* ========================================================================
         *  sortable
         * ========================================================================*/

        _setSortable: function () {
            var options = this.options;
            var afterStop = this._afterStop
            var stopCallback = function (event) {
                return afterStop(event, options);
            }
            this.options.child.find('tbody').sortable({
                axis: 'y',
                helper: this._helper,
                cursor: 'ns-resize',
                containment: 'parent',
                handle: this.options.handle,
                stop: stopCallback // call a function 
            });
        },
        _helper: function (e, ui) {
            ui.children().each(function () {
                $(this).width($(this).width());
            });
            return ui;
        },
        _afterStop: function (event, options) {
            var table = $(event.target);
            var result = '';
            table.find('tr').each(function (i) {
                var elem = $(this);
                var counter = elem.find('.row-counter');
                var id = elem.data('parentid');

                counter.html(i + 1);

                if (id !== undefined) {
                    result += id + '|';
                }
            });
            result = result.replace(/\|$/, "");
            table.attr('data-sortedids', result).data("sortedids", result);
            me.setCallBackFromData(options["custom-tableResize"].element, { e: table, value: result, tag: options.sortabletag || -1, parentid: -1 });
        },

        /* ========================================================================
         *  collapseable
         * ========================================================================*/

        _setCollapseRow: function() {
            var firstTH = this.element.find("tr:first-child th:first-child");
            var collapseIcon = (this.options.isrowcollapsed) ? "fa-expand" : "fa-compress";
            $('#COLLAPSEHANDLE', this.element).remove();

            var collapseElem = "<div id='COLLAPSEHANDLE' class='collapse-handle'><a id='COLLAPSETABLE' href='#'><i class='fa " + collapseIcon + "'></i></a></div>";
            firstTH.append(collapseElem);

            var NAMESPACE = me.getUID('CTRL_');

            if (this.options.isrowcollapsed) {
                this.options.child.addClass('nowrap');
            }

            $(this.element).on('click.' + NAMESPACE, '#COLLAPSETABLE', this, this._clickCollapseTable);
        },
        _clickCollapseTable: function (event) {
            var elem = $(this);
            var self = event.data;

            if (self.options.child.hasClass('nowrap')) {
                self.options.child.removeClass('nowrap');
                elem.children('i').removeClass('fa-expand').addClass('fa-compress');
            } else {
                self.options.child.addClass('nowrap');
                elem.children('i').removeClass('fa-compress').addClass('fa-expand');
            }
        },

        /* ========================================================================
         *  child table
         * ========================================================================*/

        _initChildTable: function() {
            var thMainList = this.element.find("tr:eq(" + this.options.useheaderrow + ") th");
            var colgroupHTML = '<colgroup>';
            thMainList.each(function () {
                var th = $(this);
                th.data("widthClass", ((th.attr('class') || '').match(/(^|\s)w-\S+/g) || [])[0]);
                var width = Number(((th.attr('class') || '').match(/(^|\s)w-\S+/g) || []).join(' ').replace("w-", ''));
                colgroupHTML += '<col width="' + width + '" />';
                this._tableWidth += (th.hasClass('hidden')) ? 0 : width;

                //  remove width class
                th.removeClass(function (index, css) {
                    return (css.match(/(^|\s)w-\S+/g) || []).join(' ');
                });
            });
            colgroupHTML += '</colgroup>';
            $('colgroup', this.element).remove();  //  Sizes will reset, but avoids scenario where header and child might get out of sync
            this.element.css('width', this._tableWidth).prepend(colgroupHTML);
            if(this.options.child) {
                $('colgroup', this.options.child).remove();
                this.options.child.css('width', this._tableWidth).prepend(colgroupHTML);
                this.options.child.removeClass('hidden');
            }
            me.setPageDimension();
        },

        /* ========================================================================
         *  public methods
         * ========================================================================*/

        // Show hidden columns. If a range isn't provided, it will show any column with the class 'hidden'
        showColumns: function (startCol, endCol) {
            var self = this;
            var useRange = (startCol >= 0 && endCol >= 0);
            this._tableWidth = 0;

            //  get width of table
            var thMainList = this.element.find("tr:eq(" + this.options.useheaderrow + ") th");
            thMainList.each(function (i) {
                if (!useRange || (this.cellIndex >= startCol && this.cellIndex <= endCol)) {
                    $(this).removeClass('hidden');
                }

                if (!$(this).hasClass('hidden')) {
                    self._tableWidth += parseInt($(this).width());
                    self.options.child.find("tr td:nth-child(" + (this.cellIndex + 1) + ")").removeClass('hidden');
                    self.element.find("colgroup col:nth-child(" + (this.cellIndex + 1) + ")").removeClass('hidden');
                }
            });
            $('[data-noresults=true] td', this.options.child).attr('colspan', thMainList.filter(":visible").length);

            this.element.css('width', this._tableWidth);
            this.options.child.css('width', this._tableWidth);
            me.setPageDimension();
        },
        // Hide columns in range
        hideColumns: function (startCol, endCol) {
            var self = this;
            this._tableWidth = 0;

            var thMainList = this.element.find("tr:eq(" + this.options.useheaderrow + ") th");
            thMainList.each(function (i) {
                if (i >= startCol && i <= endCol) {
                    $(this).addClass('hidden');
                    self.options.child.find("tr td:nth-child(" + (this.cellIndex + 1) + ")").addClass('hidden');
                    self.element.find("colgroup col:nth-child(" + (this.cellIndex + 1) + ")").addClass('hidden');
                } else {
                    self._tableWidth += parseInt($(this).width());
                }
            });
            $('[data-noresults=true] td', this.options.child).attr('colspan', thMainList.filter(":visible").length);

            this.element.css('width', this._tableWidth);
            this.options.child.css('width', this._tableWidth);
            me.setPageDimension();
        },
        resetTableWidth: function () {
            var self = this;
            this._tableWidth = 0;
            var thMainList = this.element.find("tr:eq(" + this.options.useheaderrow + ") th");

            thMainList.each(function () {
                var th = $(this);
                self._tableWidth += (th.hasClass('hidden')) ? 0 : th.width();
            });

            this.element.css('width', this._tableWidth);
            this.options.child.css('width', this._tableWidth);
        },
        getTableData: function () {
            return this.element.data();
        }
    });

    child.setTableResize = function (container, defaults) {
        var list = container !== null && $(container).is(ELEM) ? $(container) : $(ELEM, container);
        list.filter((i, self) => $(self).hasClass("table-resize")).tableResize("destroy");
        list.tableResize(defaults);
    };


    child.getTableData = function () {
        return $(ELEM).tableResize("getTableData");
    };


    // Recalculate table width
    // This function will normally be used after any custom show/hide column function
    child.resetTableWidth = function () {
        $(ELEM).tableResize("resetTableWidth");
    };


    // Show hidden columns. If a range isn't provided, all hidden columns will be shown.
    // Note: this function only works if you have a single header row
    child.showColumns = function (startCol, endCol) {
        $(ELEM).tableResize("showColumns", startCol, endCol);
    };


    // Hide columns (range is inclusive)
    // Note: this function only works if you have a single header row
    child.hideColumns = function (startCol, endCol) {
        $(ELEM).tableResize("hideColumns", startCol, endCol);
    };

    return child;
}(jQuery, FD));